<template>
  <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div class="card-header py-3 pregunta-text-enunciat">
            <h6 class="m-0 font-weight-bold text-primary">{{this.numPregunta}}. {{pregunta.enunciat | etiqueta}}</h6>
          </div>
          <!-- Card Body -->
          <div class="card-body pregunta-text-resposta">
           <b-form-input v-model="valor" placeholder=""></b-form-input>
          </div>
 </div>
 
</template>

<script>
export default {
  name: "pregunta-text",
  props: {
    pregunta:{
      type: Object,
      required: true
    },
    valorInicial:{
      type: String,
      required: true
    },
    numPregunta:{
      type: String,
      required: true
    },
    idPregunta:{
      type: Number,
      required: true
    }  
  },   
  data() {
    return {
      valor : null
    };
  },
  methods: {
   validate(){
      return true;
    },getValor(){
      return this.valor;
    } ,getIdPregunta(){
      return this.idPregunta;
    }   
  },
  mounted() {    
    this.valor = this.valorInicial;
  }
};
</script>

<style>
.pregunta-text-enunciat{
  text-align: left;
}
.pregunta-text-resposta{
  text-align: left;
}
</style>